import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { input } from '../../common/requests/base.input.ts';
import { mutation } from '../../common/requests/base.mutation.ts';
import { ResultType } from '../../main/types/result.types.ts';
import { getReadingCrittersClientUtil } from '../../main/utils/clients/readingcritters.client.util.ts';

import { mapSignUpErrorMessage } from '../mappers/sign-up-error-message.mapper.ts';

const CREATE_PARENT_ACCOUNT_MUTATION = mutation({
  createParentAccount: [
    { input: input('input', 'CreateParentAccountInput!') },
    {
      success: true,
    },
  ],
});

type CreateParentAccountInputType = VariablesOf<typeof CREATE_PARENT_ACCOUNT_MUTATION>['input'];
type CreateParentAccountResponseType = ResultOf<typeof CREATE_PARENT_ACCOUNT_MUTATION>['createParentAccount'];

export const createParentAccountMutationRequest = async (
  props: CreateParentAccountInputType
): Promise<ResultType<CreateParentAccountResponseType>> => {
  const client = getReadingCrittersClientUtil();

  try {
    const response = await client.mutation(CREATE_PARENT_ACCOUNT_MUTATION, { input: props }, { useAuth: false });

    return {
      success: Boolean(response?.createParentAccount?.success),
      data: response?.createParentAccount ?? { success: false },
    };
  } catch (error) {
    return {
      success: false,
      message: mapSignUpErrorMessage((error as Error).message),
    };
  }
};
